<mapfre-card 
    [singleCard]="false" 
    [additionalClasses]="'billing-new-container'">
    <router-outlet></router-outlet>
</mapfre-card>
<div class="col-auto no-padding w-100-mobile w-100-tab desktop-hidden billing-reward-banner">
   <ng-container *ngIf="showLoyaltyBanner">
     <app-loyalty-banner></app-loyalty-banner>
   </ng-container>
 </div>
<div class="mt-4" *ngIf="showBillingMessage && !isDisclaimer() && !isOneIncPayment">
    <div *ngIf="isAcmic" class="add-policy-row new-billing-disclaimer" [ngClass]="{'col-656565-imp':isAcmic}"> 
        {{ '*Amounts displayed may not reflect all recent policy changes or payments.' }} 
    </div>
</div>
<div class="mt-4 add-policy-row new-billing-disclaimer" *ngIf="isOneIncPayment">
    <div class="col-526570 margin-top mt24 " [ngClass]="{'col-656565-imp':isAcmic}">
        Refunds will be issued to your last credit/debit card if the refund amount is the same or less than your last
        payment amount. When the refund amount exceeds your last policy payment amount, you will be presented with other
        refund options. If you have questions regarding your refund, call
        <ng-container *ngIf="!isAcmic; else acmicPhoneNumber">
            <span class="col-red">
                1-855-627-3737</span>
        </ng-container>
        <ng-template #acmicPhoneNumber>
            <span class="text-underline col-005095 fw-500">
                1-844-295-4500</span>
        </ng-template>.
    </div>
    <div *ngIf="isAcmic" class="col-526570 margin-bottom  margin-top mt4" [ngClass]="{'mb0':!isAcmic,'mb24 col-656565-imp':isAcmic}">
        *Amounts displayed may not reflect all recent policy changes or payments.
    </div>
</div>
<div class="mt-4" *ngIf="showBillingMessage && !isDisclaimer() && !isAcmic && currPolicy">
    <div *ngIf="isAcmic" class="add-policy-row new-billing-disclaimer" [ngClass]="{'col-656565-imp':isAcmic}"> 
        {{ '*Amounts displayed may not reflect all recent policy changes or payments.' }} 
    </div>
    <app-disclaimers [policy]='currPolicy' [url]='currUrl'>
    </app-disclaimers>
</div>
<span 
	*ngIf="isNextAmountDueDisclaimer && isAcmic"
	[ngClass]="{'col-656565-imp': isAcmic}"
> 
	{{ '**May not include all fees.'}}
</span>